import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import DeleteIcon from '@mui/icons-material/Delete'
import Button from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { propOr } from 'ramda'
import { getCurrentParsedQuery } from 'utils/navigation'
import { fetchSingleTeacherDebitItemsRoutine, fetchSingleTeacherRoutine } from 'modules/teachers/ducks/actions'
import { selectCurrentTeacher } from 'modules/teachers/ducks/selectors'
import { removeTeacherSalary } from 'services/TeachersService'
import { parseNumber } from 'utils/numbers'

const DeleteSalaryModal = ({ salary }) => {
  const teacher = useSelector(selectCurrentTeacher)
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const teacherPayload = {
      ...teacher,
      balance: parseNumber(propOr(0, 'balance', teacher)) - parseNumber(salary.value)
    }

    const successCallback = () => {
      const query = getCurrentParsedQuery()
      dispatch(fetchSingleTeacherDebitItemsRoutine({ id: teacher.id, ...query }))
      dispatch(fetchSingleTeacherRoutine({ id: teacher.id }))
      handleClose()
    }

    removeTeacherSalary({
      values: {
        teacherPayload,
        teacherDebitPayload: salary
      },
      callback: successCallback
    })
  }


  return (
    <>
      <Trigger onClick={handleOpen}>
        <StyledIcon />
      </Trigger>
      <Modal
        title='Usuń wypłatę'
        open={open}
        onClose={handleClose}
      >
        Czy na pewno chcesz usunąć tę wypłatę?
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button color='primary' onClick={handleSubmit}>Usuń</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default DeleteSalaryModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(DeleteIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`
